import QuestionCreateEditModal from './QuestionCreateEditModal';

export default QuestionCreateEditModal;
